import { omrehBaseClient } from "./client";

const GetPassengerFiles = (Id) => {
  return omrehBaseClient
    .get("/FileAttachment/GetPassengerFiles", {
      params: {
        'Id': Id
      }
    });
}
const Add = (formData) => {
  return omrehBaseClient.post('/FileAttachment', formData)
}
const Delete = (id) => {
  return omrehBaseClient
    .delete("/FileAttachment/Delete", {
      params: {
        'Id': id
      }
    });
}
const fileAttachmentApi = {
   Add, GetPassengerFiles, Delete
}

export default fileAttachmentApi